import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

/**
 * Step A — confirm deleting a PERSONAL priority. Copy is PRIVATE and explicit:
 * it only affects the owner's own private priorities. NO mention of team,
 * manager, alignment, linked members, or sharing — a personal priority is the
 * owner's alone (Stage 1, structurally private).
 */
export interface PersonalPriorityDeleteDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  isAr: boolean;
  busy?: boolean;
  onConfirm: () => void;
}

export function PersonalPriorityDeleteDialog({
  open,
  onOpenChange,
  isAr,
  busy,
  onConfirm,
}: PersonalPriorityDeleteDialogProps) {
  const t = (en: string, ar: string) => (isAr ? ar : en);
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="personal-priority-delete">
        <DialogHeader>
          <DialogTitle>
            {t("Delete this personal priority?", "حذف هذه الأولوية الشخصية؟")}
          </DialogTitle>
          <DialogDescription>
            {t(
              "This only removes it from your private priorities.",
              "هذا يزيلها فقط من أولوياتك الخاصة.",
            )}
          </DialogDescription>
        </DialogHeader>
        {/* Clear breathing room between the body text and the destructive
            action (mobile-polish spacing). */}
        <DialogFooter className="mt-4" data-testid="pp-delete-footer">
          <Button
            variant="ghost"
            onClick={() => onOpenChange(false)}
            data-testid="pp-delete-cancel"
          >
            {t("Cancel", "إلغاء")}
          </Button>
          <Button
            variant="destructive"
            disabled={busy}
            onClick={onConfirm}
            data-testid="pp-delete-confirm"
          >
            {t("Delete", "حذف")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
